// extracted by mini-css-extract-plugin
export var adjacentSlide = "_mb-9";
export var arrowButtonContainer = "_mb-5";
export var arrowButtonIcon = "_mb-6";
export var carouselArrowButton = "_mb-2";
export var carouselElementContainer = "_mb-1";
export var currentSlide = "_mb-8";
export var left = "_mb-3";
export var otherSlide = "_mb-a";
export var productCarouselContainer = "_mb-0";
export var right = "_mb-4";
export var sliderOverflow = "_mb-7";